<template>
    <div class="BrokerDisclaimer">
        <MobileNav :page_title="nav_title"></MobileNav>
        <div style="margin-top: 40px;">
            <BrokerDisclaimerComponent ></BrokerDisclaimerComponent>
        </div>
    </div>
</template>

<script>
import MobileNav from "@/components/MobileNav.vue";
import BrokerDisclaimerComponent from "@/components/BrokerDisclaimerComponent.vue";
import { screenSize } from "../mixins/ScreenSize.js";

export default {
    name: 'BrokerDisclaimer',
    components: {
        MobileNav,
        BrokerDisclaimerComponent,
    },
    mixins: [screenSize],

    data() {
        return {
            nav_title: 'Broker Disclaimer'
        }
    },
}
</script>
